import { Flex } from '@gmg/gmg-react-components';
import { TFunction } from 'i18next';

type TransferStatus = 'loading' | 'success' | 'failed';

export const getTransferToastContent = (t: TFunction, transferStatus: TransferStatus, licenseSystemId?: string) => {
    const interpolation = { licenseSystemId: licenseSystemId || '-' };

    switch (transferStatus) {
        case 'loading':
            return (
                <Flex flexDirection='column' gap='8px'>
                    <span className='px12_600_normal'>{t('MoveLicensesModal.transfer_loading_toast_title', 'License system transfer in progress ...')}</span>
                    <span className='px10_400_normal'>{t('MoveLicensesModal.transfer_loading_toast_desc', 'License system {{licenseSystemId}} is being moved to another computer. This process may take a few minutes. To speed things up, restart or refresh the Application Service on the target computer.', interpolation)}</span>
                    <span className='px10_400_normal'>{t('MoveLicensesModal.transfer_loading_toast_info', 'Keep in mind that transferring a license system simply moves it to another computer—the serial number stays the same.')}</span>
                </Flex>
            );

        case 'success':
            return (
                <Flex flexDirection='column' gap='8px'>
                    <span className='px12_600_normal'>{t('MoveLicensesModal.transfer_success_toast_title', 'License transfer completed')}</span>
                    <span className='px10_400_normal'>{t('MoveLicensesModal.transfer_success_toast_desc', 'License system {{licenseSystemId}} has been moved to the selected target computer.', interpolation)}</span>
                </Flex>
            );

        case 'failed':
            return (
                <Flex flexDirection='column' gap='8px'>
                    <span className='px12_600_normal'>{t('MoveLicensesModal.transfer_failed_toast_title', 'License transfer failed')}</span>
                    <span className='px10_400_normal'>{t('MoveLicensesModal.transfer_failed_toast_desc', 'License system {{licenseSystemId}} could not be moved to the selected target computer.', interpolation)}</span>
                </Flex>
            );
    }
};
